"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CJ_VALUES = exports.CJ_QUERY_NAME = exports.CJ_COOKIE_NAME = void 0;
exports.CJ_COOKIE_NAME = "cje";
exports.CJ_QUERY_NAME = "cjevent";
exports.CJ_VALUES = {
    EU_TAG_ID: "510396733378",
    US_TAG_ID: "402859398510",
    EU_ENTERPRISE_ID: "1565262",
    US_ENTERPRISE_ID: "1564865",
    EU_ACTION_TRACKER_ID: "436608",
    US_ACTION_TRACKER_ID: "434925",
    SCRIPT_ID: "cjapitag",
    CONVERSION_PAGE_TYPE: "conversionConfirmation",
    REFERRING_CHANNEL: "Affiliate",
    ALLOWED_DOMAIN: "grover.com",
};
//# sourceMappingURL=constants.js.map